<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <i class="fas fa-times" (click)="activeModal.dismiss('Cross click')"></i>
  </div>
  <div class="modal-body">
    <p [innerHTML]="message"></p>
  </div>
  <div class="modal-footer">
    <div [ngClass]="confirmBtnClass" (click)="onDecision(true)">
      {{ confirmBtnTxt }}
    </div>
    <div [ngClass]="cancelBtnClass" (click)="onDecision(false)">
      {{ cancelBtnTxt }}
    </div>
  </div>
</div>
